import React from 'react'
import { ButtonDropdown, DropdownToggle, DropdownMenu, DropdownItem } from 'reactstrap'
import ScheduleUpload from './'
import PropTypes from 'prop-types'

export default class DropDown extends React.Component {
  constructor(props) {
    super(props)

    this.toggle = this.toggle.bind(this)
    this.state = {
      dropdownOpen: false
    }
  }

  toggle() {
    if (this.props.disabled) {
      return
    }

    this.setState(prevState => ({
      dropdownOpen: !prevState.dropdownOpen
    }))
  }

  render() {
    const buttonClassName = this.props.buttonClassName || ''

    return (
      <span title={this.props.disabledTitle}>
        <ButtonDropdown isOpen={this.state.dropdownOpen && !this.props.disabled} toggle={this.toggle}>
          <DropdownToggle caret size="sm" disabled={this.props.disabled} className={buttonClassName}>
            Create schedule
          </DropdownToggle>
          <DropdownMenu>
            <DropdownItem onClick={() => this.props.onBulkScheduleUpload()}>Bulk schedule</DropdownItem>
            <DropdownItem toggle={false}>
              <ScheduleUpload
                onSuccess={() => { this.props.onScheduleFileUploadSuccess('Schedule uploaded') }}
                onError={() => this.props.onScheduleFileUploadonError('Error Uploading', 'There was an error uploading the schedule.')}
              />
            </DropdownItem>
          </DropdownMenu>
        </ButtonDropdown>
      </span>
    )
  }
}

DropDown.propTypes = {
  disabled: PropTypes.bool,
  disabledTitle: PropTypes.string,
  buttonClassName: PropTypes.string,
  onBulkScheduleUpload: PropTypes.func.isRequired,
  onScheduleFileUploadSuccess: PropTypes.func.isRequired,
  onScheduleFileUploadonError: PropTypes.func.isRequired
}

DropDown.defaultProps = {
  disabled: false,
  disabledTitle: '',
  buttonClassName: ''
}



// WEBPACK FOOTER //
// ./src/components/scheduleUpload/dropdown.js